module.exports = __webpack_public_path__ + "static/media/SM-ST-2.7061bbd9.mp3";